export enum SystemEvents {
  LOGGED_IN = 'loggedin',
  LOGGED_OUT = 'loggedout',

  ORDER_CREATED = 'ordercreated',
}
